/* Shared press feel for kit controls: scale to 0.97 on press with the
   ease-out curve, pop back on release with the ease-pop curve. Reduced
   motion keeps the color change and drops the scale. */
export const kitPress =
  'transition-[transform,background-color,color,box-shadow,opacity] duration-200 ease-pop active:scale-[0.97] active:duration-100 active:ease-out motion-reduce:transform-none motion-reduce:transition-colors';

export const kitFocus =
  'outline-none focus-visible:ring-2 focus-visible:ring-signal focus-visible:ring-offset-1 focus-visible:ring-offset-paper-raised';
